import React from 'react';
import {useLocation} from 'react-router-dom';
import queryString from 'query-string';

import OnBoarding from '../containers/OnBoardingContainer';
import AnitaOnboarding from '../anita-onboarding';

const ANITA_ONBOARDING_ID = 5;

export default function OnboardingPage() {
  const location = useLocation();

  const queryParams = queryString.parse(location.search);

  if (Number(queryParams?.onboarding) === ANITA_ONBOARDING_ID) {
    return <AnitaOnboarding />;
  }

  return <OnBoarding />;
}
